var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",style:({
    backgroundPosition: -_vm.width * Number(_vm.size) + 'px ' + -_vm.height * Number(_vm.color) + 'px',
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    backgroundSize: 9 * _vm.width + 'px'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }